import { FiSlash } from 'react-icons/fi'

import { dashboardIconColors, type DashboardIconColorKey } from '../Icons'

interface ColorPickerProps {
  value: string | undefined
  onChange: (key: DashboardIconColorKey | undefined) => void
}

const colorKeys = Object.keys(dashboardIconColors) as DashboardIconColorKey[]

const swatchClass = (selected: boolean) =>
  `flex h-8 items-center justify-center rounded-full border-2 transition-colors ${
    selected ? 'border-base-content' : 'border-transparent hover:border-base-300'
  }`

export const ColorPicker = ({ value, onChange }: ColorPickerProps) => (
  <div role="radiogroup" aria-label="Icon color" className="flex flex-wrap items-center gap-2">
    <button
      type="button"
      role="radio"
      aria-checked={value === undefined}
      aria-label="No color"
      title="No color"
      onClick={() => onChange(undefined)}
      className={`${swatchClass(value === undefined)} w-8 text-base-content/70`}
    >
      <FiSlash size={16} />
    </button>
    {colorKeys.map((key) => (
      <button
        key={key}
        type="button"
        role="radio"
        aria-checked={value === key}
        aria-label={key}
        title={key}
        onClick={() => onChange(key)}
        className={`${swatchClass(value === key)} w-8`}
      >
        <span className={`h-5 w-5 rounded-full bg-current ${dashboardIconColors[key]}`} />
      </button>
    ))}
  </div>
)
